const MERCEDES = 'mercedes'
const BMW = 'bmw'
const JLR = 'jlr'
const VW = 'vw'
const BYD = 'byd'
const VWSG = 'vwsg'

const htaTypeDict = {
  [MERCEDES]: 'Mercedes',
  [BMW]: 'BMW',
  [JLR]: 'JLR',
  [VW]: 'Volkswagen Malaysia',
  [BYD]: 'BYD',
  [VWSG]: 'Volkswagen Singapore',
}

const HTA_TYPES = [BMW, MERCEDES, JLR, VW, BYD, VWSG]

const SG_HTA = [VWSG]

module.exports = { htaTypeDict, MERCEDES, BMW, JLR, VW, BYD, VWSG, HTA_TYPES, SG_HTA }
